module.exports = __webpack_public_path__ + "img/project17_3.png.5934d454.webp";